import { useEffect } from 'react'

import { COMMAND_PRIORITY_EDITOR } from '@eastcoal/editor/exports'
import { useEditor } from '@eastcoal/editor/hooks/useEditor'
import { $insertIsolatedNodeToNearestRoot } from '@eastcoal/editor/utils/node'

import {
  $createTableVariableNode,
  TableVariableNode
} from '../../nodes/TableVariableNode'

import { INSERT_TABLE_VARIABLE_COMMAND } from './commands'

export const TableVariablePlugin = () => {
  const editor = useEditor()

  useEffect(() => {
    editor.registerCommand(
      INSERT_TABLE_VARIABLE_COMMAND,
      payload => {
        if (!editor.hasNode(TableVariableNode)) {
          throw new Error(
            'TableVariablePlugin: TableVariableNode not registered on editor'
          )
        }
        const tableVariableNode = $createTableVariableNode(payload)
        $insertIsolatedNodeToNearestRoot(tableVariableNode)
        return false
      },
      COMMAND_PRIORITY_EDITOR
    )
  }, [editor])

  return null
}
